import React from "react";
import { Button, Modal, Setlists } from "player-components";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createNewEmptySetlist,
  selectSetlistsSetlists,
} from "../../features/setlists/setlistsSlice";
import { selectClientConfig, setError, setUserInputtingText } from "../../features/ui/uiSlice";
import { selectUser } from "../../features/auth/authSlice";
import NewSetlistModal from "../../components/NewSetlistModal";

import { logToIndexedDB, getLogsFromIndexedDB, clearLogsFromIndexedDB } from '../../indexedLogger';



// pgw 16-jul-2025 - attempt to fix setlist bug
import { store, persistor } from '../../store';


// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


import { createSetlistFromQuery } from "../CreateSetlist/createSetlistFromQuery";


// pgw 16-jul-2025 - attempt to fix setlist bug
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


// pgw 18-jul-2025


// pgw 18-jul-2025
const waitForPersist = async (delayMs = 50) => {

	debugLog('waitForPersist p1')
	debugLog('waitForPersist p1, delayMs = ', delayMs)
	try {
	  await new Promise(resolve => setTimeout(resolve, delayMs));
		debugLog('waitForPersist p2')
	  await persistor.flush();
		debugLog('waitForPersist p3')
	}
	catch(e) {
		debugLog('waitForPersist p1 e = ', e)
	}

};






export const DEBUG_LOG_KEY = 'debugLogs';

export const logToLocalStorage = (message, payload = null) => {
	const logs = JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
	const timestamp = new Date().toISOString();

	const now = new Date();
	const ukTimeWithSeconds = now.toLocaleTimeString('en-GB', {
	  hour: '2-digit',
	  minute: '2-digit',
	  second: '2-digit',
	  timeZone: 'Europe/London',
	  hour12: false
	});

	let msg = `${ukTimeWithSeconds}`;


	if (payload) {
		msg = msg + ` m=${message} p=${payload}`
// 		logs.push({ message, payload });
		logs.push(msg);
	}
	else {

		msg = msg + ` m=${message}`
		logs.push(msg);
// 		logs.push(message);
	}
	// 	logs.push({ timestamp, message, payload });
	debugLog("message = ", message)
	localStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(logs));
};



export const getLogsFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
};

export const clearLogs = () => {
  localStorage.removeItem(DEBUG_LOG_KEY);
};



export function logAllSetlists(state) {

// debugLog('logAllSetlists 1')
	  logToIndexedDB('logAllSetlists 1');

	try {

// 	  logToIndexedDB('logAllSetlists 2 state = ', state);
// 	  debugLog('logAllSetlists 2 state = ', state);

	  const setlistsObj = state.setlists;
	  const setlists = setlistsObj.setlists;

	  logToIndexedDB('App Current setlists');
	  setlists.forEach(sl => {
		logToIndexedDB('App sl.title = ', sl.title);
		sl.items.forEach(song => {
			logToIndexedDB('App song.mix = ', song.mix);
		});
	  });
	}
	catch(e) {
  		logToIndexedDB('App logAllSetlists, e = ', e);
  		logToIndexedDB(e);
  		debugLog('App logAllSetlists, e = ', e);
	}
}






const SetListsContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientConfiguration = useSelector(selectClientConfig);
  const setlists = useSelector(selectSetlistsSetlists);
  const currentUser = useSelector(selectUser);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [imageUrl, setImageUrl] = useState(
    clientConfiguration.features.setlist.defaultSetlistImageUrl
  );
  const [showCreateSetlistModal, setShowCreateSetlistModal] = useState(false);




	// pgw 18-jul-2025
//     const handleCreateNewSetlist = () => {
const handleCreateNewSetlist = async () => {

	logToIndexedDB("handleCreateNewSetlist p1, title = ", title);


		try {
			// log the current setlists
			let state = store.getState();

			logToIndexedDB('handleCreateNewSetlist before logAllSetlists p1')
			logAllSetlists(state);
			logToIndexedDB('handleCreateNewSetlist after logAllSetlists p2')
		}
		catch(e) {
			logToIndexedDB('handleCreateNewSetlist p1, e = ', e)
			debugLog('handleCreateNewSetlist p1, e = ', e)
		}




	debugLog("handleCreateNewSetlist p1 before waitForPersist()");
	await waitForPersist();
	debugLog("handleCreateNewSetlist p1 after waitForPersist()");


	logToIndexedDB('handleCreateNewSetlist before dispatch(createNewEmptySetlist) ')
    dispatch(createNewEmptySetlist({ title, subtitle, imageUrl }));
	logToIndexedDB('handleCreateNewSetlist after dispatch(createNewEmptySetlist) ')

	debugLog("handleCreateNewSetlist p1a before waitForPersist()");
	await waitForPersist();
	debugLog("handleCreateNewSetlist p1a after waitForPersist()");


	/*
	  // Optional: wait for animation / flush state
	  await sleep(1000);

	  // Optional: persist state change
	  await persistor.flush();
	*/

    setShowCreateSetlistModal(false);

	debugLog("handleCreateNewSetlist p2a before waitForPersist()");
	await waitForPersist();
	debugLog("handleCreateNewSetlist p2a after waitForPersist()");




		try {
			// log the current setlists
			let state = store.getState();
// 			debugLog('handleCreateNewSetlist p1a, state = ', state)
// 			logToIndexedDB('handleCreateNewSetlist p1a, state = ', state)
			logToIndexedDB('handleCreateNewSetlist p1a')
			logAllSetlists(state);
			logToIndexedDB('handleCreateNewSetlist p2a')
		}
		catch(e) {
			logToIndexedDB('handleCreateNewSetlist p1a, e = ', e)
			debugLog('handleCreateNewSetlist p1a, e = ', e)
		}





	debugLog("handleCreateNewSetlist p3");

  };



  const handleOpenSharedSetList = () => {
	console.log('src/containers/SetLists/index.js handleOpenSharedSetList p1');
alert('Should not be here!!!')
return;


  };



  const handleOpenNewSetlistModal = () => {

	// pgw 19-jun-2025 - testing custom setlists 
	// Check whether it's a dev site, if so allow setlist creation for anyone

	let devTest = false;
	logToIndexedDB("handleOpenNewSetlistModal p1");

	try {
		if (clientConfiguration.images.menuLogoLink) {
			debugLog("clientConfiguration.images.menuLogoLink is defined = ", clientConfiguration.images.menuLogoLink);

			if (clientConfiguration.images.menuLogoLink.toLowerCase().includes("dev")) {
				debugLog("clientConfiguration.images.menuLogoLink is defined = ", clientConfiguration.images.menuLogoLink);
				devTest = true;
			} else {
				debugLog("clientConfiguration.images.menuLogoLink NOT defined");
			}

		} else {
			debugLog("clientConfiguration.images.menuLogoLink NOT defined");
		}
	}
	catch(e) {
		debugLog("handleOpenNewSetlistModal  e = ", e);
	}

	debugLog("handleOpenNewSetlistModal  devTest = ", devTest);
	debugLog("handleOpenNewSetlistModal  setlists = ", setlists);
	


	if (devTest) {
		  setShowCreateSetlistModal(true);
		  setTitle("");
		  setSubtitle("");
	}
	else {

		if (currentUser?.subscribed) {
		  setShowCreateSetlistModal(true);
		  setTitle("");
		  setSubtitle("");
		} else {
		  dispatch(
			setError({
			  title: "Not subscribed",
			  text: <>
				<p>{clientConfiguration.features.library.subscribeConfig.playlistCreationDeniedText}</p>
				<div className="mt-4 flex justify-center">
				  <a target="_blank" rel="noreferrer" href={clientConfiguration.features.library.subscribeConfig.url}>
					<Button>{clientConfiguration.features.library.subscribeConfig.buttonLabel}</Button>
				  </a>
				</div>
			  </>,
			})
		  );
		}


	}

  };

  const handleSelectPlaylist = (setlistId) => {
    const selectedSetlist = setlists.find((s) => s.id === setlistId);
    navigate(`/setlist/${selectedSetlist.id}`);
  };


  const handleUserInputingText = (bool) => {
    dispatch(setUserInputtingText(bool));
  }


// player-application/src/containers/SetLists/index.js


const handleOpenSharedSetlist = async () => {
  console.log("[SETLIST SHARE] handleOpenSharedSetlist");

  const raw = window.prompt(
    "Enter the setlist share number (e.g. 64) or a cpsl URL"
  );

  if (!raw) return;

  const s = String(raw).trim();

  const match =
    s.match(/cpsl\s*(\d+)/i) ||
    s.match(/\/cpsl(\d+)/i) ||
    s.match(/^(\d+)$/);

  if (!match) {
    alert("That doesn't look like a share number. Example: 64");
    return;
  }

  const code = match[1];
  const targetUrl = `https://www.choirplayer.com/cpsl${code}`;

  console.log("[SETLIST SHARE] checking", targetUrl);

  try {

	try {
    	console.log("[SETLIST SHARE] before await fetch(targetUrl) targetUrl = ", targetUrl);
		const res = await fetch(targetUrl);
    	console.log("[SETLIST SHARE] after await fetch(targetUrl) res = ", res);
    	console.log("[SETLIST SHARE] after await fetch(targetUrl) res.status = ", res.status);

		if (res.status === 404) {
    	console.log("[SETLIST SHARE] after await fetch(targetUrl) returned 404 - alert and return");
		  alert(
			"That setlist could not be found.\n\n" +
			"Please check the share number and try again."
		  );
		  return;
		}
		else {
    		console.log("[SETLIST SHARE] after await fetch(targetUrl) was not 404 - continue");
		}

	}
	catch (e) {
    	console.log("[SETLIST SHARE] await fetch(targetUrl) e = ", e);
		alert('error - returning');
		return;
	}


	try {
		window.location.href = targetUrl;
	}
	catch (e) {
    	console.log("[SETLIST SHARE] e = ", e);
		alert('error - returning');
		return;
	}

  } catch (err) {
    console.error("[SETLIST SHARE] network error", err);
    alert(
      "Unable to reach the server.\n\n" +
      "Please check your connection and try again."
    );
  }
};



// pgw 18-jul-2025

const handleCloseCreateSetlistModal = async () => {

  logToIndexedDB("handleCloseCreateSetlistModal p1 Modal close initiated");

//   // Optional: wait for animation / flush state
//   await sleep(100);
// 
//   // Optional: persist state change
//   await persistor.flush();
// 
//   debugLog("Flushed, hiding modal");

  setShowCreateSetlistModal(false);

  logToIndexedDB("handleCloseCreateSetlistModal p2 Modal close done");

};

// <CreateSetlistModal onClose={handleCloseCreateSetlistModal} />

  return (
    <div className="p-4 pt-2">

		<div className="mb-2">
			<Button onClick={handleOpenSharedSetlist}>
				Open shared setlist
			</Button>
		</div>

      <Setlists
        items={setlists}
        onCreateNewSetlist={handleOpenNewSetlistModal}
        onOpenSharedSetlist={handleOpenSharedSetList}
        onSelectSetlist={handleSelectPlaylist}
      />
      <Modal
        isOpen={showCreateSetlistModal ? true : false}
        title="New Setlist"
        content={
          <NewSetlistModal
            isOpen={showCreateSetlistModal ? true : false}
            clientConfiguration={clientConfiguration}
            firstSetlist={false}
            title={title}
            setTitle={setTitle}
            subtitle={subtitle}
            setSubtitle={setSubtitle}
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            setUserInputtingText={handleUserInputingText}
          />
        }
        confirmLabel="Create"
        onConfirm={handleCreateNewSetlist}
        // onClose={() => setShowCreateSetlistModal(false)}
        onClose={handleCloseCreateSetlistModal}
        closeLabel="Close"
        confirmable={title && subtitle && imageUrl}
      />
    </div>
  );
};

export default SetListsContainer;
